import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { makeStyles, styled, ThemeProvider } from "@material-ui/core/styles";
import pinkTheme from "./themes/pinkTheme";
import { createMuiTheme } from "@material-ui/core/styles";
import { useTransition, animated, Spring } from "react-spring";
import { useSpringRef } from "react-spring";
import Wave from "react-wavify";
import LuminateLogo from "assets/images/logo.png";

const NavTitle = styled("h1")(({ theme }) => ({
  color: "#1B2340",
  letterSpacing: "2px",
  fontSize: "1vw",
  fontWeight: "bolder",
  margin: "0",
  fontFamily: "'Ubuntu', sans-serif",
  [theme.breakpoints.up("sm")]: {
    fontSize: "24px",
  },
  [theme.breakpoints.between("xs", "sm")]: {
    fontSize: "15.5px",
    letterSpacing: "1",
  },
  [theme.breakpoints.down("sm")]: {
    letterSpacing: "0",
  },
}));

const HeadText = styled("h1")(({ theme }) => ({
  color: "#664000",
  fontSize: "50px",
  fontWeight: "bolder",
  [theme.breakpoints.up("sm")]: {
    // fontSize: "24px",
  },
  [theme.breakpoints.between("xs", "sm")]: {
    // fontSize: "15.5px",
    // letterSpacing: "1",
  },
  [theme.breakpoints.down("sm")]: {
    // letterSpacing: "0",
  },
}));

const StudentCard = () => {
  return (
    <div
      className="card bg-white"
      id="studentCard"
      onClick={() => (window.location.href = "/portal/student")}
      style={{
        width: "18rem",
        boxShadow: "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",
      }}
    >
      <div className="card-body text-center">
        <h4>
          <i class="zmdi zmdi-accounts-alt zmdi-hc-5x" style={{ color: "#540000" }}></i>
        </h4>
        <br />
        <a href="#" class="stretched-link" style={{ color: "#540000" }}>
          Student
        </a>
      </div>
    </div>
  );
};

const ApplicantCard = () => {
  return (
    <div
      className="card text-white"
      onClick={() => (window.location.href = "/portal/applicant")}
      id="applicantCard"
      style={{
        width: "18rem",
        backgroundColor: "#540000",
        boxShadow:
          "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",
      }}
    >
      <div className="card-body text-center" style={{}}>
        <h4>
          <i class="zmdi zmdi-accounts-list-alt zmdi-hc-5x"></i>
        </h4>
        <br />
        <a href="#" class="stretched-link text-white">
          Applicant
        </a>
      </div>
    </div>
  );
};

const BackBox = styled("div")(({ theme }) => ({
  position: "fixed",
  height: "200%",
  width: "94vh",
  backgroundColor: "#ddd",
  // bottom: "-50%",
  transform: "rotate(-50deg)",
  left: "-90px",
  overflow: "hidden",
  zIndex: "-10",
  padding: theme.spacing(1),
}));

const theme = createMuiTheme(pinkTheme);

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [items, setItems] = useState([]);
  const transition = useTransition(isVisible, {
    from: { y: 200, opacity: 0 },
    enter: { y: 150, opacity: 1 },
    delay: 400,
    // onRest: () => setIsVisible()
  });
  const backBoxTransition = useTransition(isVisible, {
    // from: { x: "10%" },
    // to: { x: "0" },
    delay: 200,
  });

  const studentCardTransition = useTransition(isVisible, {
    from: { y: 200, opacity: 0 },
    enter: { y: 150, opacity: 1 },
    delay: 600,
    // onRest: () => setIsVisible()
  });

  const waveTransition = useTransition(isVisible, {
    from: { y: 0 },
    // to: { y: 0 },
    delay: 4000,
  });

  const applicantCardTransition = useTransition(isVisible, {
    from: { y: 200, opacity: 0 },
    enter: { y: 150, opacity: 1 },
    delay: 800,
    // onRest: () => setIsVisible()
  });

  const springRef = useSpringRef();

  springRef.start({
    to: {
      x: "0",
      opacity: "0",
      y: "0",
    },
  });

  useEffect(() => {
    setIsVisible(true);
  });

  return (
    <Router>
      {/* === === === === Transition === === === === */}
      <ThemeProvider theme={theme}>
        <div className="container-fluid m-0 p-0" style={{ overflowY: "auto" }}>
          {/* <div style={classes.box}></div> */}
          {backBoxTransition((style, item) => item && <animated.div style={style}>{/* <BackBox />  */}</animated.div>)}
          <header>
            <div className="container-fluid pre-header">
              <div
                className="row text-white p-2"
                style={{
                  height: "fit-content",
                  backgroundColor: "#240000",
                  color: "#fff",
                  boxShadow: "outset 40px 40px 40px 40px #1180F4",
                  zIndex: "950",
                }}
              >
                <div className="col-md-4 header-contact my-1">
                  <ul className="list-inline ml-1 my-0 text-white">
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-lg zmdi-hc-flip-horizontal mdc-text-red"></i> +234 815 222 589
                    </li>
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-email zmdi-hc-fw zmdi-hc-lg zmdi-hc-flip-horizontal text-white"></i>
                      <a href="mailto:info@umcatc.edu.ng" className="text-white">
                        info@umcatc.edu.ng
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-8 login-register d-flex align-items-center justify-content-end my-1" style={{ right: "0" }}>
                  <ul className="list-inline my-0">
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-twitter zmdi-hc-fw zmdi-hc-lg"></i>
                    </li>
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-facebook zmdi-hc-fw zmdi-hc-lg"></i>
                    </li>
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-instagram zmdi-hc-fw zmdi-hc-lg"></i>
                    </li>
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-skype zmdi-hc-fw zmdi-hc-lg"></i>
                    </li>
                    <li className="list-inline-item">
                      <i className="zmdi zmdi-linkedin zmdi-hc-fw zmdi-hc-lg"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="container-fluid" style={{ backgroundColor: "#fff" }}>
            <div className="row d-md-inline">
              <div className="col-lg-3 d-md-inline">
                <img
                  className="img-fluid px-3"
                  src="https://odfelbidadoc01.blob.core.windows.net/passport/46bf7d16-aeae-4e96-b80b-1966795887c0.png"
                  alt=""
                  style={{ maxWidth: "80px", maxHeight: "80px" }}
                />
              </div>
              <div className="col-lg-9 d-none d-md-inline d-flex align-content-center">
                <h1 className="d-inline" style={{ color: "#1B2340" }}>
                  <strong>THE FEDERAL POLYTECHNIC BIDA, NIGER STATE</strong>
                </h1>
              </div>
            </div>
          </div> */}
            <nav class="navbar navbar-light bg-white" style={{ borderBottom: "2.5px solid #540000" }}>
              <div class="navbar-brand" href="/portal">
                <div class="row d-flex px-3 align-middle">
                  <a href="/portal">
                    <img
                      src={LuminateLogo}
                      width="65"
                      height="65"
                      class="d-inline-block align-top"
                      alt=""
                    />
                  </a>
                  <h1 className="d-inline align-content-center m-auto px-2">
                    <NavTitle>UMCA Theological College,</NavTitle>
                    <span className="h3 mt-0 text-mute">Ilorin</span>
                  </h1>
                </div>
              </div>
            </nav>
          </header>

          <div
            className="row d-flex flex-column align-items-center justify-content-center"
          // style={{
          //   backgroundImage:
          //     "linear-gradient(rgba(0,0,0,.8), rgba(255,255,255,.3)), url('https://res.cloudinary.com/ebenofere/image/upload/v1625052203/Fed-Poly-Bida_xygluc.jpg')",
          //   backgroundRepeat: "no-repeat",
          //   backgroundSize: "cover",
          //   minHeight: "94vh",
          // }}
          >
            <div className="ml-md-5 mb-xs-4">
              {/* <h1 className="text-center" style={{ color: "#403a60", fontSize: "50px", fontWeight: "bolder" }}>
                    Welcome to Federal Polytechnic Bida Portal
                  </h1> */}
              {transition((style, item) =>
                item ? (
                  <animated.div className="col-md-12" style={style}>
                    <div className="ml-md-5 mb-xs-4">
                      <HeadText className="text-center"> Open Distance Flexible e-Learning Portal </HeadText>
                    </div>
                  </animated.div>
                ) : (
                  ""
                )
              )}
              <div className="row justify-content-around d-flex flex-row " id="actionCards">
                {studentCardTransition((style, item) =>
                  item ? (
                    <animated.div style={style}>
                      <StudentCard />
                    </animated.div>
                  ) : (
                    ""
                  )
                )}

                {applicantCardTransition((style, item) =>
                  item ? (
                    <animated.div style={style}>
                      <ApplicantCard />
                    </animated.div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div>
          </div>
          {/* </div> */}
          <Wave
            fill="url(#gradient)"
            paused={false}
            options={{
              height: 100,
              amplitude: 20,
              speed: 0.25,
              points: 3,
            }}
            style={{
              bottom: "0",
              position: "absolute",
            }}
          >
            <defs>
              <linearGradient id="gradient" gradientTransform="rotate(90)">
                <stop offset="10%" stopColor="#f4f4f7" />
                <stop offset="40%" stopColor="#9dfa" />
                <stop offset="90%" stopColor="#2d8da2" />
              </linearGradient>
            </defs>
          </Wave>

          {waveTransition((style, item) =>
            item ? (
              <animated.div style={style}>
                <Wave
                  fill="url(#gradient)"
                  options={{
                    height: 100,
                    amplitude: 22,
                    speed: 0.15,
                    points: 2,
                  }}
                  style={{
                    bottom: "0",
                    position: "absolute",
                  }}
                >
                  <defs>
                    <linearGradient id="gradient" gradientTransform="rotate(90)">
                      <stop offset="10%" stopColor="#f4f4f7" />
                      <stop offset="40%" stopColor="#90DEF2" />
                      <stop offset="90%" stopColor="#238EC5" />
                    </linearGradient>
                  </defs>
                </Wave>
              </animated.div>
            ) : (
              ""
            )
          )}
        </div>
      </ThemeProvider>
    </Router>
  );
};

export default Home;
